import { getInvestorApiUrl } from "../../utils/config";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";


interface InitialState {
  loading: boolean;
  error: null;
  kybApi: any;
  documentType: any
}

const initialState: InitialState = {
  loading: false,
  error: null,
  kybApi: "",
  documentType: []
};
export const getDocumentType = createAsyncThunk(
    "kyb/getDocumentType",
    async (payload: any, thunkApi) => {
      try {
        const params: ApiRequestParams = {
          method: "POST",
          baseUrl: getInvestorApiUrl(),
          payload,
          endpoint: "kyc/document-type",
        };
        const response = await handleFetchApi(params);
        return response.data.body;
      } catch (error: any) {
        return thunkApi.rejectWithValue(
          error.response?.data || "An error occurred"
        );
      }
    }
  );
export const kybRegisterAPi = createAsyncThunk(
  "kyb/kybRegisterAPi",
  async (payload: any, thunkApi) => {
    try {
      const params: ApiRequestParams = {
        method: "POST",
        baseUrl: getInvestorApiUrl(),
        payload,
        endpoint: "registration/user-registration",
      };
      const response = await handleFetchApi(params);
      return response.data;
    } catch (error: any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "An error occurred"
      );
    }
  }
);


const kybSlice = createSlice({
  name: "kyb",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(kybRegisterAPi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(kybRegisterAPi.fulfilled, (state, action: any) => {
        state.loading = false;
        state.kybApi = action.payload;
      })
      .addCase(kybRegisterAPi.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getDocumentType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocumentType.fulfilled, (state, action: any) => {
        state.loading = false;
        state.documentType = action.payload;
      })
      .addCase(getDocumentType.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
/// export all the actions
export default kybSlice.reducer;
